<template>
  <v-app id="rolgordijnen-page">
    <Menu />
    <v-container id="rolgordijnen" grid-list-lg>

      <v-layout row wrap>
        <!-- Rolgordijnen Block -->
        <v-flex xs12>
          <v-form ref="type" @submit.prevent="goToPhaseTwo">
            <v-card class="card-expansion">
              <v-toolbar @click="phaseOne" class='elevation-0'
                :class="stepOne + stepOneActive ? 'panel-open' : 'product-panel'">

                <img
                  :src="stepOne + stepOneActive ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')"
                  alt="">
                <v-card-title dark> <span :class="stepOne + stepOneActive ? 'step-tile-active' : 'step-title'">Type
                    Stof</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 activeProductTitle">{{rolgordijnen | formatRollcurtains}}</h4>
                <v-icon :class="stepOne + stepOneActive ? 'step-icon-active' : ''">{{toggleIcon(stepOne)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepOne">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="rolgordijnen == 'transparant' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="rolgordijnen" type="radio" name="Transparant"
                              value="transparant" required>
                            <img class="rolgordijnen-product-image pt-3 ml-4" src="../assets/gordijnen/Transparant.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>

                        </div>
                        <h4 class="mt-2 product-tile-title">Transparant</h4>
                      </v-flex>
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="rolgordijnen == 'lichtdoorlatend' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="rolgordijnen" type="radio" name="Lichtdoorlatend"
                              value="lichtdoorlatend" required>
                            <img class="rolgordijnen-product-image pt-3 ml-4"
                              src="../assets/gordijnen/Lichtdoorlatend.png" alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 product-tile-title">Lichtdoorlatend</h4>
                      </v-flex>
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="rolgordijnen == 'verduisterend' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="rolgordijnen" type="radio" name="Verduisterend"
                              value="verduisterend" required>
                            <img class="rolgordijnen-product-image pt-3 ml-4"
                              src="../assets/gordijnen/Verduisterend.png" alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 product-tile-title">Verduisterend</h4>
                      </v-flex>
                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen Transparant Block -->
        <v-flex xs12 v-if="rolgordijnen == 'transparant'">
          <v-form ref="sizes" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle" v-if="transparantWidth || transparantHeight">B {{transparantWidth}} mm x H {{transparantHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="transparantWidth"  :max="transparantMaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{transparantMaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="transparantWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="transparantHeight"  :max="transparantMaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{transparantMaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="transparantHeight" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen Lichtdoorlatend Block -->
         <v-flex xs12 v-if="rolgordijnen == 'lichtdoorlatend'">
          <v-form ref="sizes" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle" v-if="lichtdoorlatendWidth || lichtdoorlatendHeight">B {{lichtdoorlatendWidth}} mm x H {{lichtdoorlatendHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="lichtdoorlatendWidth"  :max="lichtdoorlatendMaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{lichtdoorlatendMaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="lichtdoorlatendWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="lichtdoorlatendHeight"  :max="lichtdoorlatendMaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{lichtdoorlatendMaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="lichtdoorlatendHeight" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

          <!-- Afmetingen verduisterend Block -->
         <v-flex xs12 v-if="rolgordijnen == 'verduisterend'">
          <v-form ref="sizes" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle" v-if="verduisterendWidth || verduisterendHeight">B {{verduisterendWidth}} mm x H {{verduisterendHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="verduisterendWidth"  :max="verduisterendMaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{verduisterendMaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="verduisterendWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="verduisterendHeight"  :max="verduisterendMaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{verduisterendMaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="verduisterendHeight" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Totaal Block -->
        <v-flex xs12>
          <v-form @submit.prevent="submitForm" ref="rolgordijnenForm">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseThree" class='elevation-0' :class="stepThree ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepThree  ? require('../assets/ui-elements/step3-active.png') : require('../assets/ui-elements/step3.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepThree ? 'step-tile-active' : 'step-title'">Totaal</span>
                </v-card-title>
                <v-spacer></v-spacer>
 <h4 class="mr-5 text-truncate activeProductTitle">&#8364; {{totalPrice | currency}}</h4>
                <v-icon :class="stepThree ? 'step-icon-active' : ''">{{toggleIcon(stepThree)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepThree">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Type stof -->
                      <v-flex xs4 sm2 md2><span class="total-title">Type stof:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">{{rolgordijnen | formatRollcurtains}}</span>
                      </v-flex>

                      <!-- Afmetingen -->
                      <!-- <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">Breedte {{width}} mm x Hoogte
                          {{height}} mm </span></v-flex> -->

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" :rules="quantityRules" v-model="quantity" type="number"
                              outline>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> €
                              {{totalPrice | currency}}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>

            <!-- Button voor toevoegen van een product -->
            <v-flex id="col-btn" xs12 text-xs-right>
              <v-btn :disable="btnDisable" type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>

    </v-container>
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>

<script>
import Menu from '@/components/Menu'; // Menu
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar'; // Message Container
import ApiService from '@/services/api.service'; // Api
import FormatService from '@/services/format.service'; // Filters

export default {
  components: {
    Menu,
    SnackBar
  },
  data() {
    return {
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepOneActive: false,
      stepTwoActive: false,
      transparantHeight: null,
      transparantWidth: null,
      lichtdoorlatendHeight: null,
      lichtdoorlatendWidth: null,
      verduisterendWidth: null,
      verduisterendHeight: null,
      transparantMaxWidth: 3500,
      transparantMaxHeight: 2200,
      lichtdoorlatendMaxWidth: 3500,
      lichtdoorlatendMaxHeight: 2200,
      verduisterendMaxWidth: 3500,
      verduisterendMaxHeight: 2200,
      rolgordijnen: 'transparant',
      price: 0,
      productPrijs: 0,
      quantity: 1,
      room: '',
      error: false,
      errorMsg: '',
      snackbar: false,
      color: '',
      messageTxt: '',
      btnDisable: true,
      quantityRules: [quantity => !!quantity || Messages.QuantityValidationMessage]
    }
  },
  computed: {
    totalPrice() {
      return this.quantity * this.productPrijs
    },
  },
  methods: {
    getTransparantPrice() {
      if(this.rolgordijnen == 'transparant' && this.transparantWidth > 249 && this.transparantHeight > 249){
          ApiService.getRollCurtainsPrice({
          stoftype: this.rolgordijnen,
          breedte: this.transparantWidth,
          hoogte: this.transparantHeight
        }).then(response => {
          this.productPrijs = response;
        })
      } 
    },
     getLichtdoorlatendPrice() {
      if(this.rolgordijnen == 'lichtdoorlatend' && this.lichtdoorlatendWidth > 249 && this.lichtdoorlatendHeight > 249){
          ApiService.getRollCurtainsPrice({
          stoftype: this.rolgordijnen,
          breedte: this.lichtdoorlatendWidth,
          hoogte: this.lichtdoorlatendHeight
        }).then(response => {
          this.productPrijs = response;
        })
      } 
    },
        getVerduisterendPrice() {
      if(this.rolgordijnen == 'verduisterend' && this.verduisterendWidth > 249 && this.verduisterendHeight > 249){
          ApiService.getRollCurtainsPrice({
          stoftype: this.rolgordijnen,
          breedte: this.verduisterendWidth,
          hoogte: this.verduisterendHeight
        }).then(response => {
          this.productPrijs = response;
        })
      } 
    },
    phaseOne() {
      this.stepOne = !this.stepOne;
      this.error = false;
    },
    phaseTwo() {
      this.stepTwo = !this.stepTwo;
      this.error = false;
    },
    phaseThree() {
      this.stepThree = !this.stepThree;
      this.error = false;
    },
    goToPhaseTwo(e) {
      if (
        e.target.elements.Transparant.validity.valid ||
        e.target.elements.Lichtdoorlatend.validity.valid ||
        e.target.elements.Verduisterend.validity.valid) {
        this.stepOne = false;
        this.stepTwo = true;
        this.error = false;
        this.stepOneActive = true;
        this.getTransparantPrice()
        this.getLichtdoorlatendPrice()
        this.getVerduisterendPrice()
      } else {
        this.error = true;
        this.errorMsg = Messages.TypeValidationMessage;
      }
    },
    goToPhaseThree() {
       
      if(this.rolgordijnen == 'transparant'){
        if(this.transparantWidth > 249 && this.transparantHeight > 249){
   this.getTransparantPrice()
    this.stepOne = false;
        this.stepTwo = false;
        this.stepTwoActive = true;
        this.stepThree = true;
        this.error = false;
        }else {
         this.error = true;
        this.errorMsg = Messages.SizesValidationMessage;
      } 
      } 

        if(this.rolgordijnen == 'lichtdoorlatend'){
       
        if(this.lichtdoorlatendWidth > 249 && this.lichtdoorlatendHeight > 249){
   this.getLichtdoorlatendPrice()
    this.stepOne = false;
        this.stepTwo = false;
        this.stepTwoActive = true;
        this.stepThree = true;
        this.error = false;
        }else {
         this.error = true;
        this.errorMsg = Messages.SizesValidationMessage;
      } 
      } 

      if(this.rolgordijnen == 'verduisterend'){
        console.log(this.rolgordijnen)
        if(this.verduisterendWidth > 249 && this.verduisterendHeight > 249){
   this.getVerduisterendPrice()
    this.stepOne = false;
        this.stepTwo = false;
        this.stepTwoActive = true;
        this.stepThree = true;
        this.error = false;
        }else {
         this.error = true;
        this.errorMsg = Messages.SizesValidationMessage;
      } 
      } 
      
      
    },
    submitForm() {
      if (this.$refs.rolgordijnenForm.validate()) {
   
          this.stepOne = false;
          this.stepThree = false;
          this.stepOneActive = false;
          this.stepTwoActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
       if(this.rolgordijnen == 'transparant'){
         this.getTransparantPrice()
            this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.rolgordijnen,
            breedte: this.transparantWidth,
            hoogte: this.transparantHeight,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
       }

         if(this.rolgordijnen == 'lichtdoorlatend'){
           this.getLichtdoorlatendPrice()
            this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.rolgordijnen,
            breedte: this.lichtdoorlatendWidth,
            hoogte: this.lichtdoorlatendHeight,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
       }

         if(this.rolgordijnen == 'verduisterend'){
           this.getVerduisterendPrice()
            this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.rolgordijnen,
            breedte: this.verduisterendWidth,
            hoogte: this.verduisterendHeight,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
       }
        
      } else {
        this.snackbar = true;
        this.color = 'error';
        this.messageTxt = Messages.NoProductsMessage
      }
    },
    toggleIcon(value) {
      if (value) {
        return 'fal fa-minus-circle';
      } else {
        return 'fal fa-plus-circle';
      }
    },
    inputChecked(e) {
      if (e.target.validity.valid) {
        this.error = false;
      }
    },
    sliderInput(value) {
      if (value > 249) {
        this.error = false;
      }
    },
  },
  filters: {
    ...FormatService
  } 
}
</script>


<style scoped>
#rolgordijnen-page {
    background-color: #fff;
}



.card-expansion {
    box-shadow: none;
    border: 1px solid #eaeaea;
}

.min {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    top: 0;
    left: 0;
    left: -5%;
    top: -15%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.max {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    clear: both;
    right: -55%;
    top: -34%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.sizeRange {
    border-radius: 4px;
    display: inline-block;
    width: 120px;
    height: 60px;
    position: relative;
    top: -1em;
    padding: 1em;
    vertical-align: middle;
    line-height: 60px;
}

.info-height {
    color: #707070;
    font-size: 16px;
    font-weight: 400;
}

.size-unit {
    position: relative;
    top: -3em;
    line-height: 30px;
    text-align: center;
}

.product-panel {
    border-top: 3px solid #b4b4b4;
    background-color: #fff;
}

.panel-open {
    border-top: 3px solid #006fb3;
    background-color: #fff;
}

.step-title {
    font-size: 15px;
    font-weight: 700;
    color: #b4b4b4;
}

.step-tile-active {
    font-size: 15px;
    font-weight: 700;
    color: #006fb3;
}

.step-icon-active {
    color: #006fb3;
}

.next-step {
    border-radius: 4px;
    height: 60px;
}

.activeProductTitle {
    color: #b4b4b4;
    font-size: 16px;
    font-weight: 400;
}

.product-tile {
    border: 1px solid #d0d0d0;
}

.product-tile-title {
    font-weight: 400;
    font-size: 19px;
    color: #707070;
}

.rolgordijnen-product-image {
    position: relative;
    right: 10px;
}

.selected {
    border: 2px solid #006fb3;
}


.seperator-line {
    border: 1px solid #b4b4b4;
}

/* The container */
.radio-container {
    display: block;
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

}

/* Hide the browser's default radio button */
.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    position: absolute;
    bottom: -3px;
    right: 10px;
    height: 35px;
    width: 36px;
    background-color: transparent;
    border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input~.checkmark {
    background-color: transparent;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked~.checkmark {
    background-color: #006fb3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked~.checkmark:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
    top: 8px;
    left: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-image: url('../assets/ui-elements/checkmark.png');
    background-repeat: no-repeat;
}

.rolgordijnen-product-image {
    width: 35%;
}

.plooi-product-image {
    width: 50%;
}

.sub-product-tile {
    border: 1px solid #eaeaea;
}

.subproduct-tile-title {
    color: #707070;
    font-size: 18px;
    font-weight: 400;
}

.total-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}

.price-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}


.total-item {
    color: #707070;
    font-size: 13px;
    font-weight: 400;
}


.price-total {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.end-total-title {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.form-btn {
    border-radius: 4px;
    height: 60px;
    margin: 0 !important;
    width: 180px;
}

.icon-size {
    font-size: 20px;
}

#col-btn {
    padding-right: 0;
    padding-left: 0;
}

@media screen and (max-width: 1024px) {
 .rolgordijnen-product-image {
    width: 50%;
  }
}

@media screen and (max-width: 425px) {
    .size-unit {
        position: relative;
        top: -2.5em;
    }

    .form-btn {
        width: 100%;
    }

    #height-help {
        margin: 0 auto;
        text-align: center;
        justify-content: center;
    }

    .info-height {
        font-size: 13px;
    }

    .activeProductTitle {
        font-size: 14px;
    }
}

@media screen and (max-width: 320px) {
    .size-unit {
        position: relative;
        top: -3em;
    }

    .activeProductTitle {
        display: none;
    }

}
</style>
